export const cidadesVizinhas = ["Tubarão", "Criciúma", "Urussanga", "Lauro Müller", "Braço do Norte", "São Ludgero", "Içara", "Araranguá", "Laguna", "Imbituba"];

export const regiao = [
  { nome: "Orleans", wikidata: "Q1784752", km: 0, x: 424, y: 360 },
  { nome: "Tubarão", wikidata: "Q1815730", km: 30, x: 661, y: 462 },
  { nome: "Criciúma", wikidata: "Q1439157", km: 36, x: 359, y: 662 },
  { nome: "Urussanga", wikidata: "Q22063758", km: 18, x: 399, y: 510 },
  { nome: "Lauro Müller", wikidata: "Q651077", km: 11, x: 336, y: 392 },
  { nome: "Braço do Norte", wikidata: "Q903373", km: 15, x: 528, y: 280 },
  { nome: "São Ludgero", wikidata: "Q2662610", km: 12, x: 519, y: 328 },
  { nome: "Grão-Pará", wikidata: "Q1764998", km: 21, x: 487, y: 195 },
  { nome: "Cocal do Sul", wikidata: "Q1765012", km: 27, x: 395, y: 589 },
  { nome: "Siderópolis", wikidata: "Q1759010", km: 30, x: 313, y: 586 },
  { nome: "Treviso", wikidata: "Q22063766", km: 24, x: 285, y: 508 },
  { nome: "Pedras Grandes", wikidata: "Q1121962", km: 13, x: 512, y: 433 },
  { nome: "Morro da Fumaça", wikidata: "Q1758949", km: 33, x: 492, y: 637 },
  { nome: "Nova Veneza", wikidata: "Q961509", km: 37, x: 252, y: 623 },
  { nome: "Forquilhinha", wikidata: "Q1784729", km: 47, x: 273, y: 728 },
  { nome: "Içara", wikidata: "Q1764963", km: 39, x: 417, y: 695 },
  { nome: "Capivari de Baixo", wikidata: "Q1750765", km: 34, x: 702, y: 441 },
  { nome: "Gravatal", wikidata: "Q1764929", km: 25, x: 638, y: 333 },
  { nome: "Jaguaruna", wikidata: "Q1764984", km: 38, x: 645, y: 603 },
  { nome: "Laguna", wikidata: "Q1615291", km: 52, x: 849, y: 477 },
  { nome: "Imbituba", wikidata: "Q986545", km: 62, x: 942, y: 247 },
  { nome: "Araranguá", wikidata: "Q626231", km: 67, x: 262, y: 906 },
  { nome: "Sombrio", wikidata: "Q1784827", km: 89, x: 143, y: 1067 },
];

export const cidadesAtendidas = regiao.map((cidade) => cidade.nome);

export const listar = (cidades) => `${cidades.slice(0, -1).join(", ")} e ${cidades[cidades.length - 1]}`;
